import React from 'react';
import { Trans } from '@lingui/macro';

const LegalNoticeTab = () => {
  return (
    <section className='PrivacyNotice-section'>
      <div className='container'>
        <h1><Trans>Mentions légales</Trans></h1>

        <p><strong><Trans>Version en vigueur au 16/06/2025</Trans></strong></p>

        <h2><Trans>Éditeur de l'application</Trans></h2>
        <p><Trans>Vous êtes actuellement sur l'application REPAT (l'« Application »).</Trans></p>
        <p><Trans>L'Application est éditée et gérée par la société Repat Founders, de droit français, enregistrée au RCS de Paris sous le numéro 934051723, au capital social de 1000 euros, dont le siège social se situe 66 Avenue des Champs Élysées 75008 PARIS, représentée par son président Monsieur Diabi Karamoko.</Trans></p>
        <p><Trans>La présente Application est soumise au droit français.</Trans></p>

        <h2><Trans>Directeur de publication</Trans></h2>
        <p><Trans>Le représentant légal et le directeur de publication est Monsieur Diabi Karamoko, domicilié à l'adresse susmentionnée.</Trans></p>

        <h2><Trans>Hébergement</Trans></h2>
        <p><Trans>La présente Application est hébergée par Akamai Technologies en France.</Trans></p>

        <h2><Trans>Contact</Trans></h2>
        <p><Trans>Toute réclamation ou notification doit être adressée à l'adresse email : hello[at]repat.africa.</Trans></p>

        <h2><Trans>Propriété intellectuelle</Trans></h2>
        <p><Trans>Le site https://www.repat.africa est protégé par les dispositions du Code de la propriété intellectuelle, notamment par celles de ses dispositions relatives à la propriété littéraire et artistique, aux droits d'auteur et à la protection des bases de données.</Trans></p>

        <p><Trans>Ces droits sont la propriété exclusive de REPAT FOUNDERS. Le Code de la propriété intellectuelle n'autorise aux termes de l'article L.133-5, d'une part, que les copies ou reproductions strictement réservées à l'usage privé du copiste et non destinées à une utilisation collective et, d'autre part, que les analyses et les courtes citations dans un but d'exemple et d'illustration.</Trans></p>

        <p><Trans>De même, l'article L.342-3 du Code de la propriété intellectuelle n'autorise que l'extraction ou la réutilisation d'une partie non substantielle du contenu d'une base de données mise à la disposition du public par son titulaire. Par conséquent, toute représentation ou reproduction non autorisée des sites de REPAT FOUNDERS, par quelque moyen que ce soit, est strictement interdite sous peine de poursuites judiciaires. Le contrevenant s'expose à des sanctions civiles et pénales et notamment aux peines prévues aux articles L.335-2 et L.343-1 du Code de la propriété intellectuelle.</Trans></p>

        <h2><Trans>Liens hypertextes</Trans></h2>
        <p><Trans>Bien que nous apportons la plus grande rigueur dans la sélection des liens que nous proposons vers d'autres sites du réseau internet, REPAT FOUNDERS ne saurait être tenu responsable du contenu présent sur ces sites.</Trans></p>

        <h2><Trans>Responsabilité</Trans></h2>
        <p><Trans>REPAT FOUNDERS ne saurait être tenu responsable des dommages directs ou indirects pouvant résulter de l'utilisation du site ou de l'impossibilité d'y accéder, notamment en cas de maintenance, de mise à jour ou de dysfonctionnement technique.</Trans></p>

        <h2><Trans>Droit applicable et juridiction compétente</Trans></h2>
        <p><Trans>Les présentes mentions légales sont régies par le droit français. En cas de litige, les tribunaux français seront seuls compétents.</Trans></p>
      </div>
    </section>
  )
}

export default LegalNoticeTab
